import { useEffect } from 'react'
import { useLocation } from 'react-router'

export const useScrollToIdOnPage = (id: string | null) => {
  const OFFSET = 60 // handles the overlap of the navigation bar

  useEffect(() => {
    let timeoutId: number | undefined
    let attempts = 0
    const maxAttempts = 50
    const interval = 50

    const tryScroll = () => {
      if (!id) return

      const element = document.getElementById(id)
      if (element) {
        const topPosition = element.getBoundingClientRect().top + window.scrollY - OFFSET
        window.scrollTo({
          top: topPosition,
          behavior: 'smooth',
        })
      } else if (attempts < maxAttempts) {
        attempts++
        timeoutId = window.setTimeout(tryScroll, interval)
      }
    }

    tryScroll()

    return () => {
      if (timeoutId) window.clearTimeout(timeoutId)
    }
  }, [id])
}

export const useScrollToLocationHashIdOnPage = (enabled = true) => {
  const location = useLocation()
  useScrollToIdOnPage(enabled ? location.hash.slice(1) : null)
}
